import firebase from 'firebase/app';
import firestore from 'firebase/firestore';

// Initialize Firebase
var config = {
    apiKey: "AIzaSyAnGHSZ-7_zfakcnAZKVgOcC1HmFyqhgWs",
    authDomain: "ninja-smoothies-2116c.firebaseapp.com",
    databaseURL: "https://ninja-smoothies-2116c.firebaseio.com",
    projectId: "ninja-smoothies-2116c",
    storageBucket: "ninja-smoothies-2116c.appspot.com",
    messagingSenderId: "842304521466"
};
const firebaseApp = firebase.initializeApp(config);
// firebaseApp.firestore().settings({ timestampInSnapshots: true })


export default firebaseApp.firestore()


// WEBPACK FOOTER //
// ./src/firebase/init.js